<script setup lang="ts">
import { useResolver } from '../composables/resolver'
import Input from '../components/Input.vue'
import Result from '../components/Result.vue'
const { code, hasLatinCharacters, result } = useResolver()
</script>

<template>
<div class="h-[calc(100dvh-144px)] flex flex-col gap-3 justify-center items-center">
    <h1 class="text-center font-medium text-neutral-600 dark:text-neutral-400">
        Εισαγάγετε το πρόθεμα της πινακίδας του οχήματος
    </h1>

    <Input v-model="code" />

    <Result
        :result="result"
        :error="
            hasLatinCharacters
                ? 'Παρακαλώ χρησιμοποιήστε ελληνικούς χαρακτήρες.'
                : undefined
        "
    />
<!--
    <a href="/locations" class="underline underline-offset-4 text-zinc-900 font-medium dark:text-zinc-200">Προβολή όλων</a> -->
</div>
</template>
